import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-addfuel-expense',
  templateUrl: './addfuel-expense.component.html',
  styleUrls: ['./addfuel-expense.component.css']
})
export class AddfuelExpenseComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data:any){

  }

  ngOnInit(): void {
    
  }

}
